import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {ChatRoomsEnum, FeaturesEnum, OdontoBookingEnum} from 'presentation/constants';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useCallChatRoom, useMediaQueries} from 'presentation/pages';
import {useNavigate} from 'react-router-dom';
import {UseOdontoConfirmBookingModalsProps} from './types';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

export function useOdontoConfirmBookingModals({
	handleBack,
	setBookingState,
}: UseOdontoConfirmBookingModalsProps) {
	const {isMobile} = useMediaQueries();
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();
	const {isEnabled: isHideConfirmationBookingModalEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_HIDE_CONFIRMATION_BOOKING_MODAL,
	);

	const {protocolNumber, isRebooking, bookingNumber} = useBookingStore(
		state => state.bookingData,
	);
	const navigate = useNavigate();

	const alertModalpaperStyles = {
		style: {
			maxWidth: 420,
			margin: isMobile ? 16 : 'auto',
			flex: isMobile ? 1 : 'initial',
		},
	};

	const dataTagIdSuccess = isRebooking
		? AppointmentBookingEnum.REALIZOU_REMARCACAO_CONSULTA
		: AppointmentBookingEnum.REALIZOU_AGENDAMENTO_COM_SUCESSO;

	const handleCallChatRoom = async () => {
		await callChatRoom(ChatRoomsEnum.ODONTO);
	};

	const handleCloseErrorDialogState = () => {
		setBookingState(null);
	};
	const handleCloseBackToProfissionalSelection = () => {
		setBookingState(null);

		handleBack();
	};

	const handleCloseSuccessDialogState = () => {
		if (!bookingNumber) {
			setBookingState(null);
			return;
		}

		const path = OdontoBookingEnum.ODONTO_BOOKING_CONFIRMATION.replace(':id', bookingNumber);

		navigate(path);
		setBookingState(null);
	};

	return {
		handleCallChatRoom,
		handleCloseErrorDialogState,
		handleCloseBackToProfissionalSelection,
		handleCloseSuccessDialogState,
		dataTagIdSuccess,
		alertModalpaperStyles,
		protocolNumber,
		callChatRoomIsLoading,
		navigate,
		isHideConfirmationBookingModalEnabled,
	};
}
